export * from './colaborador-autocomplete.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/colaborador-autocomplete/index.ts